<template>
  <div class="xinsheng-warp system-warp">
    <FilterForm
        :formData="filterData"
        :filters="filters"
        @submit="handleSubmit"
        @reset="handleReset"
        @changeDept="changeDept"
    />
    <div class="system-btn user-btn">
      <el-button type="primary" size="small" icon="el-icon-plus" @click="customFastFlow"
      >添加速录</el-button
      >
    </div>
    <div class="container">
      <div class="right">
        <CollectionTable
            :tableColumn="tableColumn"
            :tableData="tableData"
            @nameDrawer="handleNameDrawer"
            :page="pagination.page"
            :size="pagination.size"
            @delete="handleDelete"
        />
        <CollectionPagination
            :total="total"
            @currentChange="currentChange"
            @sizeChange="sizeChange"
        />
      </div>
    </div>

    <el-dialog
        v-model="dialogVisible"
        title="自定义快捷跟进"
        width="300"
    >
      <el-form :model="fastFlowForm" label-width="auto">
        <el-form-item label="内容">
          <el-input v-model="fastFlowForm.name" placeholder="请输入自定义内容"/>
        </el-form-item>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="handleSubmitFastFlow">
            确定
          </el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ElButton, ElMessage, ElMessageBox,ElDialog, ElInput,ElForm,ElFormItem } from "element-plus";
import { useStore } from "vuex";
import { computed, onMounted, reactive, ref } from "vue";
import FilterForm from "@/components/filter";
import CollectionTable from "@/components/table";
import CollectionPagination from "@/components/pagination";
import { filters, tableColumn } from "./index.js";
import { reset } from "@/until";
import {getChannelList} from "@/api/method/channel";
import {getUserByDept} from "@/api/method/common";
import {
  putFastFlow,
  postFastFlow,
  deleteFastFlow
} from "@/api/method/system";

export default {
  name: "Collection",
  props: ["options", "departments"],
  components: {
    FilterForm,
    CollectionTable,
    CollectionPagination,
    [ElButton.name]: ElButton,
    [ElDialog.name]: ElDialog,
    [ElInput.name]:  ElInput,
    [ElForm.name]:  ElForm,
    [ElFormItem.name]:  ElFormItem,
  },

  setup() {
    const { dispatch, state } = useStore();
    const filterData = reactive({
      date: null,
      deptId:null,
      userId: null,
      source: null,
      name: null
    });

    onMounted(() => {
      getList();
      getDepartList()
      loadChannelList();
    });
    const myFilters = ref(filters);
    const deptList = ref([]);
    const getDepartList = async () => {
      await dispatch("departmentList");
      deptList.value = state.departmentList.map((item) => ({
        label: item.fullName,
        val: item.id,
      }));
      myFilters.value[0][0].option = deptList.value;
    };
    const userList = ref([]);
    const changeDept = async (id) => {
      const res = await getUserByDept(id);
      filterData.userId = null;
      userList.value = res.data.map((item) => ({
        label: item.nickname,
        val: item.id,
      }));
      myFilters.value[0][1].option = userList.value;
    };

    const channelList = ref([]);
    const loadChannelList = async () => {
      const res = await getChannelList();

      channelList.value = res.data.map((item) => ({
        label: item.name,
        val: item.id,
      }));

      myFilters.value[1][0].option = channelList.value;
    }

    const pagination = reactive({
      page: 1,
      size: 10,
    });
    const tableData = computed(
      () => (state.fastFlowList && state.fastFlowList.records) || []
    );
    const total = computed(
      () => state.fastFlowList && state.fastFlowList.total
    );
    const getList = () => {
      const { date ,...params} = filterData;

      const startTime = date && date[0];
      const endTime = date && date[1];
      dispatch("fastFlowList", {
        startTime,
        endTime,
        ...params,
        ...pagination,
      });
    };
    const currentChange = (page) => {
      pagination.page = page;
      getList();
    };
    const sizeChange = (size) => {
      pagination.size = size;
      getList();
    };

    const handleSubmit = () => getList();
    const handleReset = () => {
      reset(filterData);
      getList();
    };

    const dialogVisible = ref(false);

    const customFastFlow = async () => {
      console.log("adasdasfasasfs");
      dialogVisible.value= true;
    };

    const fastFlowForm = reactive({
      name: '',
      id: ''
    })

    const handleSubmitFastFlow =async () => {
      const { id, ...params } = fastFlowForm;
      if (id) {
        const res = await putFastFlow({ id, ...params });
        if (res.code == 200) {
          ElMessage.success("编辑成功！");
          getList();
        } else {
          ElMessage.error(res.msg);
        }
      } else {
        const res = await postFastFlow(params);
        if (res.code == 200) {
          ElMessage.success("保存成功！");
          getList();
        } else {
          ElMessage.error(res.msg);
        }
      }
      fastFlowForm.name='';
      fastFlowForm.id = null;
      dialogVisible.value= false;
    };

    const isShowDrawer = ref(false);
    const handleDrawerClose = () => (isShowDrawer.value = false);
    const drawerId = ref(null);
    const handleNameDrawer = (row) => {
      isShowDrawer.value = true;
      drawerId.value = row.customerId;
    };

    /**客户详情-上一个和下一个 */
    const handleNextCustomer = () => {
      const index =
        state.collectionList.records.findIndex(
          (item) => item.customerId == drawerId.value
        ) + 1;
      if (index == state.collectionList.records.length) {
        ElMessage.error("已经是最后一个客户了！");
        return;
      }
      drawerId.value = state.collectionList.records[index].customerId;
    };
    const handlePrevCustomer = () => {
      const index =
        state.collectionList.records.findIndex(
          (item) => item.customerId == drawerId.value
        ) - 1;
      if (index < 0) {
        ElMessage.error("已经是第一个客户了！");
        return;
      }
      drawerId.value = state.collectionList.records[index].customerId;
    };

    const handleDelete = async (id) => {
      ElMessageBox.confirm("确定要刪除该选项吗?", "提示", {
        closeOnClickModal: false,
        closeOnPressEscape: false,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const res = await deleteFastFlow(id);
          if (res.code == 200) {
            ElMessage({
              type: "success",
              message: "删除成功!",
            });
            getList();
          } else {
            ElMessage({
              type: "error",
              message: res.msg,
            });
          }
        })
        .catch(() => {});
    };

    return {
      filters,
      filterData,
      handleSubmit,
      handleReset,
      tableData,
      tableColumn,
      total,
      isShowDrawer,
      handleDrawerClose,
      handleNameDrawer,
      drawerId,
      currentChange,
      sizeChange,
      pagination,
      changeDept,
      handleDelete,
      handlePrevCustomer,
      handleNextCustomer,
      dialogVisible,
      customFastFlow,
      handleSubmitFastFlow,
      fastFlowForm,
    };
  },
};
</script>

<style lang="scss" scoped>
.user-btn {
  padding-bottom: 40px;
}
.container {
  display: flex;
  height: auto;
  .left {
    width: 250px;
    background: #f5f6f9;
    margin-right: 24px;
    padding: 20px;
  }
  .right {
    flex: 1;
    background-color: #fff;
    overflow: hidden;
  }
}
</style>

<style lang="scss">
.company-block {
  margin-bottom: 20px;
}

.company-block .el-input__inner {
  background: white !important;
}
.depart-tree {
  background: #f5f6f9;
  .el-tree-node__content {
    background: #f5f6f9;
  }
}
</style>

